import { getAuthToken } from "../utils/auth";
import axios from 'axios';

const Base_Url = process.env.REACT_APP_BASE_URL;

export const fetchAllNonApprovedPosts = async (setPosts, setTotalPages, filters, page, limit) => {
    try {
        const token = await getAuthToken();
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const res = await axios.get(`${Base_Url}/api/posts/all-posts`, {
                params: {
                    status: filters.status,
                    sort: filters.sort,
                    search: filters.search,
                    page: page,
                    limit
                }
            });
            setPosts(res.data.posts);
            const totalPages = Math.ceil(res.data.totalPosts / limit);
            setTotalPages(totalPages);
            return res.data
        }
    } catch (err) {
        console.error(err);
        setPosts([]);
    }
};

export const fetchAllApprovedPosts = async (setPosts, setTotalPages, filters, page, limit) => {
    try {
        const res = await axios.get(`${Base_Url}/api/posts/all-approved-posts`, {
            params: { sort: filters.sort, search: filters.search, page: page, limit }
        });
        setPosts(res.data.posts);
        const totalPages = Math.ceil(res.data.totalPosts / limit);
        setTotalPages(totalPages);
        return res.data;
    } catch (err) {
        // console.error(err);
        setPosts([]);
    }
};

export const fetchlimitedApprovedPosts = async (setPosts) => {
    try {
        const limit = 12;
        const res = await axios.get(`${Base_Url}/api/posts/all-approved-posts`, { params: { limit } });
        setPosts(res.data.posts);
    } catch (err) {
        setPosts([]);
    }
};

export const fetchUserPosts = async (setPosts, setTotalPages, filters, page, limit) => {
    try {
        const token = await getAuthToken();
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const res = await axios.get(`${Base_Url}/api/posts/user-posts`, {
            params: {
                status: filters.status,
                sort: filters.sort,
                search: filters.search,
                page: page,
                limit
            }
        });
        setPosts(res.data.posts);
        const totalPages = Math.ceil(res.data.totalPosts / limit);
        setTotalPages(totalPages);
        return res.data;
    } catch (err) {
        console.error(err);
        setPosts([]);
    }
};


export const fetchUserDonations = async (setPosts, page, limit, setTotalPages, search) => {
    try {
        const token = await getAuthToken();
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const res = await axios.get(`${Base_Url}/api/donations/user?page=${page}&limit=${limit}&search=${search}`);
        setPosts(res.data.posts);
        setTotalPages(res.data.totalPages);
    } catch (err) {
        console.error(err);
    }
};


const isDescriptionLong = (description) => {
    const textContent = new DOMParser().parseFromString(description, 'text/html').body.textContent || '';
    const wordCount = textContent.split(/\s+/).length;
    return wordCount > 50;
};

export const fetchSinglePost = async (id, setPostData, setData, truncated) => {
    try {
        const token = await getAuthToken();
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const res = await axios.get(`${Base_Url}/api/posts/single/${id}`);
        setPostData(res.data.postData);
        if (truncated) {
            const shouldTruncate = isDescriptionLong(res.data.postData.description);
            setData(shouldTruncate);
        }
        else {
            let attachmentValue = `${Base_Url}/assets/postThumbnails/${res.data.postData.attachment}`
            setData(attachmentValue);
        }
    } catch (err) {
        console.error(err);
    }
};

export const handleApprove = async (e, postId, status, setLoading, setPosts) => {
    try {
        e.preventDefault()
        setLoading(true);
        const token = await getAuthToken();
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const res = await axios.put(`${Base_Url}/api/posts/approve-post/${postId}`, { status });
            setTimeout(() => {
                setPosts(res.data.posts);
                setLoading(false);
            }, 2000)
        }
    } catch (err) {
        console.error(err.response ? err.response.data : 'Server error');
    }
};

export const deletePosts = async (postToDelete) => {
    try {
        const token = getAuthToken();
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const res = await axios.post(`${Base_Url}/api/posts/delete-post`, { id: postToDelete._id });
            return res;
        }
    } catch (e) {
        return false;
    }
}